import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../auth/auth-service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.css']
})
export class MainMenuComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;

  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.isLoggedIn$ = this.authService.isLoggedIn;
  }

  onLogout(): void {
    this.authService.logout();
  }

  isAdmin() {
    return this.authService.isAdmin.map(
      (isAdmin: boolean) => {
          this.authService.unsubscribeIsAdmin();
          if (!isAdmin ) {
              return false;
          } else {
            return true;
          }
      }
  );
  }

}



// WEBPACK FOOTER //
// ./src/app/main-menu/main-menu.component.ts